import React from 'react';

import Header from '../../components/user/header/Header.jsx';
import SubIntro from '../../components/user/sub_intro2/Intro.jsx';
import Content from '../../components/user/sub2_1/sub2_1_4/Content.jsx';

import Footer from '../../components/user/footer/Footer.jsx';

import s2_1_4_bg from '../../assets/images/s2_1_4_bg.png';

import '../../styles/user/common.css';
import '../../styles/user/default.css';
import '../../styles/user/fixed.css';
import '../../styles/user/font.css';
import '../../styles/user/footer.css';
import '../../styles/user/header.css';
import '../../styles/user/main.css';
import '../../styles/user/slick-theme.css';
import '../../styles/user/slick.css';
import '../../styles/user/sub.css';

export default function Sub2_1_4() {
  return (
    <>
      <Header />
      <SubIntro
        backgroundImage={s2_1_4_bg}
        mainTitle="마케팅 전문가"
        productName="CREAMBOT"
        productModel="T11"
        description="초협소 통로에서도 충돌없는 스마트한 이동"
        theme="dark"
        showWhiteFilter={true}
      />
      <Content />
      <Footer />
    </>
  );
}
